import React, { useState } from "react";

// components
import RangeSlider from "@/shared/RangeSlider";
import RadioGroup from "@/shared/RadioGroup";

// helpers
import { mapInputNumberProps } from "./helpers";

// interfaces
import { IGenderFilter } from "./IMoreFiltersForm";

// assets
import styles from "@/assets/styles/components/Form/more-filters-form.module.scss";


const RADIO_OPTIONS = [
  { label: "Female", value: "female" },
  { label: "Male", value: "male" }
];

const GenderFilter = ({ onChange, femaleValue, maleValue }: IGenderFilter) => {
  const [isFemale, setIsFemale] = useState(!maleValue);

  const onRangeChange = (key: string, value: string) => {
    if (isFemale) {
      onChange(key, value)

      return;
    }

    onChange(key, value)
  };

  const onRadioChange = (key: string) => {
    if (key === "male") {
      setIsFemale(false);

      return;
    }
    
    setIsFemale(true);
  };

  const radioValue = isFemale ? "female" : "male";

  return (
    <div className="locl-more-filters__wrapper locl-more-filters__gender" data-testid="locl-more-filters-gender">
      <RadioGroup
        wrapperClassName={styles["locl-more-filters__gender__radio"]}
        onChange={(e) => onRadioChange(e.target.value)}
        name="gender"
        options={RADIO_OPTIONS}
        value={radioValue}
        data-testid="locl-more-filters-gender-radio-buttons"
      />
      {
        isFemale
          ? <RangeSlider
            withInputs
            key="female__range"
            onChange={(e) => onRangeChange("female__range", e.join("__"))}
            value={femaleValue}
            min={0} // can set min from response facets.female.min?.value
            max={100} // can set max from response facets.female.max?.value
            className="locl-more-filters__age_input"
            wrapperClassName={styles["locl-more-filters__input-wrap"]}
            inputDataTest="locl-more-filters-input-female"
            {...mapInputNumberProps("female__range", "")}
          />
          : <RangeSlider
            withInputs
            key="male__range"
            onChange={(e) => onRangeChange("male__range", e.join("__"))}
            value={maleValue}
            min={0} // can set min from response facets.male.min?.value
            max={100} // can set max from response facets.male.max?.value
            className="locl-more-filters__age_input"
            wrapperClassName={styles["locl-more-filters__input-wrap"]}
            inputDataTest="locl-more-filters-input-male"
            {...mapInputNumberProps("male__range", "")}
          />
      }
    </div>
  );
};

export default GenderFilter;
